import React from 'react';

export interface ValidationErrorsProps {
    errors: string[],
    defaultError?: string,
    qa?: string,
}

/**
 * Validation Errors
 */
export const ValidationErrors = (props: ValidationErrorsProps) => {

    const hasErrors = props.errors && props.errors.length > 0;
    const defaultError = props.defaultError ?? 'An error has occurred.';
    return (
        <>
            { !hasErrors && <div>{ defaultError }</div>}

            {
                hasErrors && (
                    <div data-qa={ props.qa }>
                        {
                            props.errors.map((error, i) => {
                                return <span key={i} dangerouslySetInnerHTML={{ __html: error }} />
                            })
                        }
                    </div>
                )
            }
        </>
    )
};

export default ValidationErrors;